import './BetradarMTScoreboard.less';
import React from 'react';
import clsx from 'clsx';
import { isAmericanFootbal, isSportWithWidgetScoreboard } from '../match-statistics/utils';
import { sportsWithBRTimer } from './betradar-scoreboard/utils';
import { WidgetWrapper } from '../match-statistics/sportradar-widgets/WidgetWrapper';
import { SrWidgetMatchScoreboard } from '../match-statistics/sportradar-widgets/SrWidgetMatchScoreboard';
import { SrWidgetLmtScoreboard } from '../match-statistics/sportradar-widgets/SrWidgetLmtScoreboard';

function BetradarMTScoreboard({
    matchId,
    sportId,
    hideBetradarData = false
}: {
    matchId: number;
    sportId: number;
    hideBetradarData?: boolean;
}) {
    const brTimer = sportsWithBRTimer(sportId);
    const showMatchScoreboard = isSportWithWidgetScoreboard(sportId);
    const className = clsx('sr-scoreboard-widget', {
        'hide-br-timer': !brTimer,
        'sr-scoreboard-widget-customized': hideBetradarData,
        'betradar-af': isAmericanFootbal(sportId),
        'bonus-info-scoreboard-fixer': sportId === 3 || sportId === 1
    });

    return (
        <WidgetWrapper>
            {!showMatchScoreboard && (
                <SrWidgetLmtScoreboard matchId={matchId + ''} sportId={sportId + ''} className={className} />
            )}
            {showMatchScoreboard && (
                <SrWidgetMatchScoreboard matchId={matchId + ''} sportId={sportId + ''} className={className} />
            )}
        </WidgetWrapper>
    );
}

export default BetradarMTScoreboard;
